import Utility from "../utilities/utility";

const baseUrl = process.env.REACT_APP_BASE_URL;

class ShippingService {

    constructor(){

        this.token = localStorage.getItem('token');
    }

    createShipment(containerId, shippingDate, arrivalDate, destinationCountryId,originCountryId, description, supplierId, branchId) {

        const token = localStorage.getItem('token');
        const requestData = {
            "containerId": containerId,
            "supplierId": supplierId,
            "shippingDate": shippingDate,
            "arrivalDate": arrivalDate,
            "destinationCountryId": destinationCountryId,
            "originCountryId": originCountryId,
            "description": description,
            "branchId" : branchId
        };

        return fetch(baseUrl + '/manager/shipment/create', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }

    addProduct(shipmentId, productId, quantity) {

        console.log('Got to add shipment');
        const token = localStorage.getItem('token');
        const requestData = {

            "shipmentId": shipmentId,
            "orderProductId": productId,
            "quantity": quantity
        };

        return fetch(baseUrl + '/shipment/add/product', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }

    shipmentProducts(shipmentId, searchTerm, supplierUniqueId) {

        const token = localStorage.getItem('token');

        const requestData = {

            "searchTerm": searchTerm,
           "supplierUniqueId": supplierUniqueId
        };


        return fetch(baseUrl + '/shipment/products/' + shipmentId, {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            
            body: JSON.stringify(requestData)
        });
    }

    shipmentList(desc, containerId, countryId, shipmentUniqueId) {

        const token = localStorage.getItem('token');

        const requestData = {
           'description' : desc,
           'containerId' : containerId,
           'countryId' : countryId,
           'shipmentUniqueNumber' : shipmentUniqueId
           
        }

        return fetch(baseUrl + '/shipment/list', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }

    findShipment(shipmentId) {

        

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/shipment/find/' + shipmentId, {
            method: 'GET',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });
    }

    removeShipmentProducts(orderProductId) {

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/shipment/products/remove/' + orderProductId, {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });
    }




    updateShipment(shipmentData) {

        const token = localStorage.getItem('token');


        return fetch(baseUrl + '/manager/shipment/update', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(shipmentData)
        });
    }

    setShipmentUnloaded(shipmentId) {

        const token = localStorage.getItem('token');


        return fetch(baseUrl + '/manager/shipment/setUnloaded/'+shipmentId, {
            method: 'PUT',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });
    }

    shipmentFeeList(shipmentId){


        return fetch(baseUrl + '/shipment/fee/list/'+shipmentId, {
            method: 'GET',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': this.token,
                'Accept': 'application/json',
            }
        });
    }


    shipmentFeeTypeList(){


        return fetch(baseUrl + '/manager/shipment/fee/type/list', {
            method: 'GET',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': this.token,
                'Accept': 'application/json',
            }
        });
    }

    addShipmentFee(shipmentId, feeTypeId, amount, source){

        const requestData = {

            'shipmentId' : shipmentId,
            'feeTypeId' : feeTypeId,
            'amount' : amount,
            'source' : source
            
         }

        return fetch(baseUrl + '/manager/shipment/add/fee', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': this.token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }


    setShipmentProductBoxQuantity(shipmentProductId, quantity){

        const requestData = {

            'shipmentProductId' : shipmentProductId,
            'quantity' : quantity
           
            
         }

        return fetch(baseUrl + '/manager/shipment/set/box/quantity', {
            method: 'PUT',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': this.token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }

    updateShipmentProduct(shipmentId, orderProductId, quantity) {

        const token = localStorage.getItem('token');

        let shipmentProductData = {

            'shipmentId': shipmentId,
            'orderProductId' : orderProductId,
            'quantity' : quantity
        };

        return fetch(baseUrl + '/shipment/product/update', {
            method: 'PUT',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(shipmentProductData)
        });
    }

    confirShipment(shipmentId) {

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/manager/shipment/confirm/'+shipmentId, {
            method: 'PUT',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });
    }

    setCountryShipmentBranch(countryId ,branchId) {

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/manager/shipment/set/country/branch/'+countryId+'/'+branchId, {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });
    }

    setShipmentBranch(shipmentId ,branchId) {

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/manager/shipment/set/branch/'+shipmentId+'/'+branchId, {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });
    }


    countryShipmentList(countryId) {

        const token = localStorage.getItem('token');

        return fetch(baseUrl + '/manager/country/shipment/list/'+countryId, {
            method: 'GET',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });
    }


    generateShipmentUniqueNumbers() {
            return fetch(baseUrl + "/admin/shipment/generate-shipment-unique-numbers", {
                method: "POST",
                headers: {
                    "Authorization": localStorage.getItem("token")
                }
            });
        }



}

export default ShippingService;